module.exports = __webpack_public_path__ + "static/media/watch.ecec1fde.svg";